import { debounce } from 'lodash';

const minicartDrawer = document.querySelector('#CartDrawer');
const initMinicart = () => {
  if (!minicartDrawer) return;

  minicartDrawer
    .querySelectorAll('.minicart__close, .minicart__backdrop')
    .forEach((closer) => {
      closer.addEventListener('click', () => closeMinicart());
    });

  minicartDrawer.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMinicart();
  });

  const popup = minicartDrawer.querySelector('.minicart__popup');
  if (popup) {
    const closePopup = popup.querySelector('.btn');
    const popupList = popup.querySelector('.minicart__popup-list');
    closePopup.addEventListener('click', () => {
      minicartDrawer.classList.remove('minicart__drawer--changed');
      setTimeout(() => {
        popupList.innerHTML = '';
      }, 1000);
    });
  }

  loadMinicart();
};

const lineUpdate = (productRow, lineIndex, quantity) => {
  productRow.classList.add('loading');
  ShopifyAPI.changeItem(
    lineIndex,
    quantity,
    () => {
      loadMinicart();
    },
    (XMLHttpRequest, textStatus) => {
      productRow.classList.remove('loading');
      const errorWrapper = productRow.querySelector('.minicart__product-error');
      if (errorWrapper && XMLHttpRequest?.responseJSON?.description) {
        errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
        errorWrapper.classList.remove('hidden');
        setTimeout(() => {
          errorWrapper.classList.add('hidden');
        }, 3000);
      }
    },
  );
};

const initQtyButtons = () => {
  if (!minicartDrawer) return;
  minicartDrawer
    .querySelectorAll('.minicart__product[data-line-index]')
    .forEach((productRow) => {
      const lineIndex = productRow.dataset.lineIndex;
      const qtyContainer = productRow.querySelector('.minicart__product-qty');
      if (qtyContainer) {
        const minusBtn = qtyContainer.querySelector(
          '.minicart__product-qty-change--minus',
        );
        const plusBtn = qtyContainer.querySelector(
          '.minicart__product-qty-change--plus',
        );
        const qtyInput = qtyContainer.querySelector(
          '.minicart__product-qty-value',
        );

        if (minusBtn && plusBtn && qtyInput) {
          const stock =
            qtyInput?.dataset?.stock >= 0 ? qtyInput.dataset.stock : -1;

          minusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const newValue = parseInt(qtyInput.value) - 1;
            if (newValue > 0) {
              plusBtn.disabled = false;
              lineUpdate(productRow, lineIndex, newValue);

              if (newValue <= 1) {
                minusBtn.disabled = true;
              }
            }
          });

          plusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const newValue = parseInt(qtyInput.value) + 1;
            if (stock >= 0) {
              if (stock >= newValue) {
                minusBtn.disabled = false;

                if (stock == newValue) {
                  plusBtn.disabled = true;
                }
                lineUpdate(productRow, lineIndex, newValue);
              }
            } else {
              lineUpdate(productRow, lineIndex, newValue);
            }
          });
        }
      }

      const removeLink = productRow.querySelector('a.minicart__product-remove');
      if (removeLink && removeLink.href) {
        removeLink.addEventListener('click', (e) => {
          e.preventDefault();
          lineUpdate(productRow, lineIndex, 0);
        });
      }
    });
};

const initWishlistButton = () => {
  minicartDrawer
    .querySelectorAll('.minicart__product[data-line-index]')
    .forEach((productRow) => {
      const lineIndex = productRow.dataset.lineIndex;
      const swymJson = productRow.querySelector('[data-swym-data]');
      const wishlist = productRow.querySelector('.minicart__product-wishlist');
      if (wishlist && swymJson) {
        const swymData = JSON.parse(swymJson.innerText);
        wishlist.addEventListener('click', () => {
          productRow.classList.add('loading');
          _swat.addToWishList(swymData, function (e) {
            lineUpdate(productRow, lineIndex, 0);
          });
        });
      }
    });
};

const checkShoppableProducts = async () => {
  const changedLines = minicartDrawer.querySelectorAll(
    '.minicart__product[data-product-title][data-shoppable="false"]',
  );
  if (changedLines.length > 0) {
    minicartDrawer.classList.add('minicart__drawer--loading');
    minicartDrawer.classList.add('minicart__drawer--changed');

    for (var i = 0; i < changedLines.length; i++) {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: changedLines[i].dataset.lineIndex,
          quantity: 0,
        }),
      }).catch((error) => {
        console.error(`Error: ${error}`);
      });
    }
  }
  return changedLines.length > 0;
};

const checkRts = async () => {
  const changedLines = minicartDrawer.querySelectorAll(
    '.minicart__product[data-product-title][data-line-properties][data-new-rts]',
  );
  if (changedLines.length > 0) {
    const minicartPopup = minicartDrawer.querySelector('.minicart__popup');
    if (minicartPopup) {
      const list = minicartPopup.querySelector('.minicart__popup-list');
      changedLines.forEach((changedLine) => {
        const listEl = document.createElement('li');
        listEl.innerText = `${changedLine.dataset.productTitle} ${
          changedLine.dataset.newRts == 'true'
            ? theme.strings.changed_popup.now_rts
            : theme.strings.changed_popup.not_rts
        }`;
        list.appendChild(listEl);
      });
    }
    minicartDrawer.classList.add('minicart__drawer--loading');
    minicartDrawer.classList.add('minicart__drawer--changed');

    for (var i = 0; i < changedLines.length; i++) {
      const changedLine = changedLines[i];
      const properties = {};
      JSON.parse(changedLine.dataset.lineProperties).forEach((property) => {
        if (property.length <= 1) return;
        properties[property[0]] = property[1];
      });
      properties['_rts'] = changedLine.dataset.newRts;
      const qtyInput = changedLine.querySelector(
        'input.minicart__product-qty-value',
      );
      const qty = qtyInput ? parseInt(qtyInput.value) : 1;

      const changes = {
        line: changedLine.dataset.lineIndex,
        quantity: qty,
        properties: properties,
      };

      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(changes),
      }).catch((error) => {
        console.error(`Error: ${error}`);
      });
    }
  }
  return changedLines.length > 0;
};

const initVatField = () => {
  const invoiceCheckbox = minicartDrawer.querySelector(
    'input[type="checkbox"]#requestInvoiceMinicart[data-linked-name]',
  );
  const vatText = minicartDrawer.querySelector(
    'input[type="text"]#vatTextMinicart[data-linked-name]',
  );
  if (!invoiceCheckbox || !vatText) return;
  const invoiceInput = minicartDrawer.querySelector(
    `input[name="${invoiceCheckbox.dataset.linkedName}"]`,
  );
  const vatTextInput = minicartDrawer.querySelector(
    `input[name="${vatText.dataset.linkedName}"]`,
  );
  if (!invoiceInput || !vatTextInput) return;

  invoiceCheckbox.addEventListener('change', () => {
    if (!invoiceCheckbox.checked) {
      vatTextInput.value = '';
      $(vatText).slideUp(() => {
        vatText.value = '';
      });
    } else {
      $(vatText).slideDown();
    }
    vatText.disabled = !invoiceCheckbox.checked;
  });

  vatText.addEventListener('input', () => {
    invoiceInput.value =
      invoiceCheckbox.checked && vatText.value.length > 0 ? 'yes' : 'no';
    vatTextInput.value = invoiceCheckbox.checked ? vatText.value : '';
  });
};

const loadMinicart = async () => {
  if (!minicartDrawer) return;
  await fetch(`${Shopify.routes.root}cart?view=minicart`)
    .then(async (res) => res.text())
    .then(async (data) => {
      const minicartDom = new DOMParser().parseFromString(data, 'text/html');
      const minicartContent = minicartDom.querySelector('#MinicartContent');
      const minicartDrawerContent =
        minicartDrawer.querySelector('.minicart__content');
      if (minicartContent && minicartDrawerContent) {
        minicartDrawerContent.innerHTML = minicartContent.innerHTML;
      }
      if (window.ShopifyAPI)
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((res) => res.json())
          .then((data) => window.ShopifyAPI.updateCartItemsCount(data));
    });

  if (await checkShoppableProducts()) {
    loadMinicart();
  } else {
    if (await checkRts()) {
      loadMinicart();
    } else {
      minicartDrawer.classList.remove('minicart__drawer--loading');
      initQtyButtons();
      initWishlistButton();
      initVatField();
      const form = minicartDrawer.querySelector('form');
      if (form) $(form).parsley();
    }
  }
};

const openMinicart = () => {
  if (
    !minicartDrawer ||
    document.querySelector('html').classList.contains('template-cart')
  )
    return;
  minicartDrawer.classList.add('minicart__drawer--open');
  minicartDrawer.focus();
  document.querySelector('html').classList.add('minicart-open');
  loadMinicart();
};

const closeMinicart = () => {
  if (!minicartDrawer) return;
  minicartDrawer.classList.remove('minicart__drawer--open');
  minicartDrawer.blur();
  document.querySelector('html').classList.remove('minicart-open');
};

export {
  initMinicart,
  openMinicart,
  closeMinicart,
  loadMinicart,
  checkRts,
  checkShoppableProducts,
};
